import { gql } from "@apollo/client";

export const PAY_DONATE = gql`
    mutation payDonate($amount: Int!) {
        payDonate(amount: $amount) {
            ok
            nextUrl
        }
    }
`;

export const PAY_CREDIT_DONATE = gql`
    mutation payCreditDonate($amount: Int!) {
        payCreditDonate(amount: $amount) {
            ok
        }
    }
`;

export const PAY_DEPOSIT = gql`
    mutation payDeposit($amount: Int!) {
        payDeposit(amount: $amount) {
            ok
            nextUrl
        }
    }
`;

export const PAY_FINE = gql`
    mutation payFine {
        payFine {
            ok
            nextUrl
        }
    }
`;

export const WARNING_RESOLVE = gql`
    mutation warningResolve {
        warningResolve {
            ok
        }
    }
`;

export const PAY_WARNING_TRANSACTION_RECEIPT = gql`
    mutation payWarningTransactionReceipt($uploadId: String!, $amount: Int!) {
        payWarningTransactionReceipt(uploadId: $uploadId, amount: $amount) {
            ok
        }
    }
`;

export const PAY_DEPOSIT_TRANSACTION_RECEIPT = gql`
    mutation payDepositTransactionReceipt($uploadId: String!, $amount: Int!) {
        payDepositTransactionReceipt(uploadId: $uploadId, amount: $amount) {
            ok
        }
    }
`;

export const PAY_DONATE_TRANSACTION_RECEIPT = gql`
    mutation payDonateTransactionReceipt($uploadId: String!, $amount: Int!) {
        payDonateTransactionReceipt(uploadId: $uploadId, amount: $amount) {
            ok
        }
    }
`;
